export function attachAuthHeader(http, getToken) {
  http.interceptors.request.use(
    config => {
      const token = getToken?.()
      if (token) {
        config.headers = config.headers || {}
        config.headers.Authorization = `Bearer ${token}`
      }

      if (!config.params) config.params = {}
      return config
    },
    error => Promise.reject(error),
  )
}

export function attach401Redirect(http, {redirectToLogin}) {
  http.interceptors.response.use(
    r => r,
    async error => {
      const status = error?.response?.status ?? error?.status

      if (status === 401) {
        await redirectToLogin()
      }

      return Promise.reject((error && error.response) || error)
    },
  )
}

export function attach403Alert(http, showError) {
  http.interceptors.response.use(
    r => r,
    async error => {
      const response = error?.response ?? error
      const status = response?.status

      if (status === 403 && showError) {
        const msg = response?.data?.message || 'Forbidden'
        showError(msg)
      }

      return Promise.reject((error && error.response) || error)
    },
  )
}
